// reducer.js
import {
  REQUEST_START,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  REQUEST_RETRY,
  REMOVE_ERROR,
  RESET_STATE
} from '../../constants/refect-bulk'

const initialState = {
  loading: false,
  resources: {}, // Holds data by resource ID
  errors: {}, // Holds errors by resource ID
  retryCounts: {}, // Holds retry count by resource ID
  successList: [],  // Track successful patient posts
  failureList: []  // Track failed patient posts
}

const refectBulkReducer = (state = initialState, action) => {
  const { resourceId, error, data, retryCount } = action.payload || {}

  switch (action.type) {
    case REQUEST_START:
      return {
        ...state,
        loading: true,
        retryCounts: { ...state.retryCounts, [resourceId]: 0 }
      }

    case REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        resources: { ...state.resources, [resourceId]: data },
        successList: [...state.successList, resourceId],
        failureList: state.failureList.filter((id) => id !== resourceId), // Remove from failure list
        errors: { ...state.errors, [resourceId]: null } // Clear errors on success
      }

    case REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, [resourceId]: error },
        failureList: [...state.failureList, resourceId], // Add to failure list
        successList: state.successList.filter((id) => id !== resourceId) // Remove from success list
      }

    case REQUEST_RETRY:
      return {
        ...state,
        retryCounts: { ...state.retryCounts, [resourceId]: retryCount }
      }

    case REMOVE_ERROR:
      const { [action.payload]: removedError, ...remainingErrors } =
        state.errors
      return {
        ...state,
        errors: remainingErrors // Remove the error for the specified resource ID
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default refectBulkReducer
